import { getRoot, types } from 'mobx-state-tree'
import { RootModel } from '@shared/data-access'

export const MODEL_NAME = 'PolicyRecordings'

const PolicyRecording = types.model({
  contractNumber: types.maybeNull(types.string),
  datetime: types.maybeNull(types.string),
  filename: types.maybeNull(types.string),
  format: types.maybeNull(types.string),
  size: types.maybeNull(types.number),
  source: types.maybeNull(types.string),
  url: types.maybeNull(types.string),
})

export const Model = RootModel.named(MODEL_NAME)
  .props({
    id: types.identifier,
    recordings: types.maybeNull(types.array(PolicyRecording)),
  })
  .volatile((self) => ({
    _store: getRoot(self)[`${MODEL_NAME}Store`],
  }))

export default Model
